import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import {
  mediaMaxDesktopSmall,
  PaneClosedIcon,
  PaneOpenedIcon,
} from '@root/shared/ui-kit'

import { tradesTableViewOptionAtom } from '../../atoms/reatom-trading-tables'
import { TradesTableViewOption } from '../../model/trades-table-view-option'

import type { ClassNameProps } from '@root/shared/react'

const ToggleTradesViewOption: Record<
  TradesTableViewOption,
  TradesTableViewOption
> = {
  [TradesTableViewOption.Table]: TradesTableViewOption.Chart,
  [TradesTableViewOption.Chart]: TradesTableViewOption.Table,
}
const ToggleTradesViewOptionIcon: Record<
  TradesTableViewOption,
  React.ReactNode
> = {
  [TradesTableViewOption.Table]: <PaneClosedIcon size={16} />,
  [TradesTableViewOption.Chart]: <PaneOpenedIcon size={16} />,
}

type Props = {} & ClassNameProps

export const ToggleTradesViewOptionButton = (props: Props) => {
  const { t } = useTranslation()

  const [tradesTableViewOption, setTradesTableViewOption] = useAtom(
    tradesTableViewOptionAtom,
  )

  const isChecked = tradesTableViewOption === TradesTableViewOption.Chart

  return (
    <Root
      type="button"
      onClick={() =>
        setTradesTableViewOption((it) => ToggleTradesViewOption[it])
      }
      className={props.className}
      radius="rounded"
      aria-checked={isChecked}
    >
      {ToggleTradesViewOptionIcon[tradesTableViewOption]}{' '}
      <Text>{t('trade.trade-panel')}</Text>
    </Root>
  )
}

const Root = styled(Button)`
  --button-radius-rounded: 6px;

  background: var(--background-2);
  color: var(--text-9);

  height: 20px;
  padding-inline: 8px;

  font-size: 11px;
  font-weight: 600;

  &[aria-checked='true'] {
    color: var(--text-11);
    background: var(--background-3);
  }

  &:hover {
    background: var(--background-4);
    color: var(--text-11);
  }
`
const Text = styled.span`
  ${mediaMaxDesktopSmall(css`
    display: none;
  `)}
`
